import { atom } from "nanostores";

export interface Episode {
  attributes: {
    title: string;
    description: string;
    image_url: string;
    media_url: string;
    published_at: string;
  };
  podcastTitle: string;
  podcastId: string;
}
export const isPlayerOpen = atom(false);
export const loadedEpisode = atom<Episode | null>(null);
export const loadedVideo = atom<any>(null);
export const playerState = atom<"playing" | "paused" | "stopped">("stopped");

export const isBackgroundPlayerPaused = atom(false);

export function playEpisode(episode: Episode) {
  if (loadedEpisode.get() || playerState.get() === "playing") return;
  isPlayerOpen.set(true);
  loadedEpisode.set(episode);
}
